module.exports = __webpack_public_path__ + "img/600.504cc748.svg";